const DELTA = 0;

const isLessBounds = (sourceBounds, testBounds) =>
  sourceBounds.top - testBounds.top < DELTA ||
  sourceBounds.left - testBounds.left < DELTA ||
  sourceBounds.right - testBounds.right > DELTA;

export default isLessBounds;
